<template>
  <div id="automated-messages">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-button round size="mini" icon="el-icon-s-data" type="warning" @click="logDialog = !logDialog">{{ $t("automatedMessages.submissionHistory") }}</el-button>
          </li>
          <!-- <li class="nav-item">
            <el-button
              round
              size="mini"
              icon="fas fa-plus"
              type="primary"
              @click="
                voucherId = null;
                voucherModal = true;
              "
              >Voucher Ekle</el-button
            >
          </li> -->
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.messages.title") }}</h5>
              <span v-html="$t('totalContent', [$store.state.automatedmessages.items.length])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <div class="card-body pt-3" v-if="getEnums">
            <div class="automated-head mt-3" v-for="(category, index) in getEnums.find(x => x.title == 'AutomatedMessageCategory').enums" :key="index + 'category'">
              <div class="automated-title">
                <div class="text">{{ category.displayName }}</div>
                <div class="btns" v-if="category.key == 0">
                  <!-- <el-button size="mini" circle icon="el-icon-refresh" :loading="loading == 'loadingList'" type="success" @click="refreshList"></el-button> -->
                  <el-button
                    size="mini"
                    round
                    icon="fas fa-plus"
                    type="primary"
                    @click="
                      voucherId = null;
                      voucherModal = true;
                    "
                  >
                    {{ $t("automatedMessages.addNewDraft") }}
                  </el-button>
                </div>
              </div>
              <div class="automated-list" v-if="getCategoryItem(category.key).length > 0">
                <!-- <div class="automated-list-head custom-grid-table-header" v-if="index == 0">
                  <div>İleti adı, Konu</div>
                  <div class="text-center">Görüntüleme</div>
                  <div></div>
                </div> -->
                <div class="automated-list-item" style="margin-bottom:.5rem;" v-for="item in getCategoryItem(category.key)" :key="item.id" :class="{ passive: !item.isActive }">
                  <div class="item-head">
                    <div class="item-title">
                      {{ getEnumsDisplay("AutomatedMessageType", item.type) }}
                      <i class="el-icon-loading" v-if="loading == item.id + 'spin'"></i>
                    </div>
                    <span>{{ item.title }}</span>
                  </div>
                  <div class="text-center"><el-switch v-model="item.isActive" @change="toggleItem(item)"></el-switch></div>
                  <div class="d-flex justify-content-end" style="gap:0.2rem">
                    <el-tooltip effect="dark" :content="$t('buttonGeneral.edit')" placement="top">
                      <el-button size="mini" circle icon="fas fa-pen" type="primary" v-if="category.key != 7" @click="openEditModal(item)"></el-button>
                      <el-button
                        v-else
                        size="mini"
                        circle
                        icon="fas fa-pen"
                        type="primary"
                        @click="
                          reminderId = item.id;
                          reminderModal = true;
                          reminderItem = item;
                        "
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('buttonGeneral.delete')" placement="top">
                      <el-button size="mini" circle icon="fas fa-trash" type="danger" :loading="loading == item.id + 'delete'" @click="deleteItem(item.id)" v-if="category.key == 0" style="margin:0px;"></el-button>
                    </el-tooltip>
                  </div>
                </div>
              </div>
              <div class="automated-empty" v-if="getCategoryItem(category.key).length == 0">
                {{ $t("automatedMessages.noDataThisCategory") }}
              </div>
            </div>
          </div>
          <div class="card-footer"></div>
        </div>
      </div>
      <el-dialog :close-on-click-modal="false" :visible.sync="voucherModal" :title="modalTitle && voucherId != null ? $t('automatedMessages.editVoucher', [modalTitle]) : $t('automatedMessages.addVoucher')" class="large" center modal-append-to-body destroy-on-close>
        <VoucherAddUpdate :id="voucherId" v-if="voucherModal" @closeDialog="voucherModal = false" @deleteMe="deleteItem" />
      </el-dialog>
      <!-- <el-dialog :close-on-click-modal="false" :visible.sync="reminderModal" :title="'Edit ' + (reminderItem != null ? reminderItem.title : '') " class="large" center modal-append-to-body destroy-on-close> -->
      <el-dialog :close-on-click-modal="false" :visible.sync="reminderModal" :title="$t('automatedMessages.edit', [reminderItem != null ? getEnumsDisplay('AutomatedMessageType', reminderItem.type) : ''])" class="large" center modal-append-to-body destroy-on-close>
        <ProgramReminder :id="reminderId" v-if="reminderModal" @closeDialog="reminderModal = false" />
      </el-dialog>
      <el-dialog :close-on-click-modal="false" :visible.sync="logDialog" :title="$t('automatedMessages.automaticMessageRecords')" class="large" center modal-append-to-body destroy-on-close>
        <AutomatedLogs v-if="logDialog" @closeDialog="logDialog = false" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import AutomatedLogs from "../../components/automatedmessages/AutomatedLogs.vue";
import VoucherAddUpdate from "../../components/automatedmessages/VoucherAddUpdate";
import ProgramReminder from "../../components/automatedmessages/ProgramReminder.vue";
import axios from "axios";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.automatedMessages")
    };
  },
  name: "Automatedmessages",
  components: {
    VoucherAddUpdate,
    AutomatedLogs,
    ProgramReminder
  },
  data() {
    return {
      modalTitle: null,
      reminderItem: null,
      logDialog: false,
      reminderId: null,
      reminderModal: false,
      voucherId: null,
      voucherModal: false,
      axios,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "questionlibrary",
      height: 200,
      listShort: null,
      loading: false
    };
  },
  methods: {
    async refreshList() {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = "loadingList";
      await this.$store.dispatch("getAutomatedMessagesList");
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    },
    openEditModal(item) {
      this.voucherId = item.id;
      this.voucherModal = true;
      this.modalTitle = this.getEnumsDisplay("AutomatedMessageType", item.type);
    },
    getCategoryItem(category) {
      return this.$store.state.automatedmessages.items.filter(x => x.category == category);
    },
    async toggleItem(item) {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = item.id + "spin";
      var res = await this.$store.dispatch("toggleAutomatedMessage", item.id);

      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
      item.isActive = res.data.data;
    },
    async deleteItem(id) {
      if (this.listShort != null) clearTimeout(this.listShort);
      this.loading = id + "delete";
      var res = await this.$store.dispatch("deleteAutomatedMessage", id);
      if (!res.data.alert.hasError) {
        await this.$store.dispatch("getAutomatedMessagesList");
      }
      this.listShort = setTimeout(async () => {
        this.loading = false;
      }, 500);
    }
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    }
  },

  async created() {
    await this.$store.dispatch("getAutomatedMessagesList");
  }
};
</script>
<style lang="less" scoped>
.automated-head {
  .automated-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-weight: bold;
    font-size: 15px;
  }
  .automated-list {
    margin-top: 0.5rem;
    .automated-list-head {
      padding: 10px 20px;
      grid-template-columns: 1fr 90px 120px;
    }
  }
}
.automated-list-item {
  padding: 10px 20px;
  grid-template-columns: 1fr 90px 120px;
  display: grid;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  align-items: center;
  border-radius: 8px;
  background-color: #f1f1f1;
  .item-head {
    .item-title {
      font-weight: bold;
    }
  }
  &:last-child {
    margin-bottom: unset;
  }
  &.passive {
    background-color: #fff2f2 !important;
  }
}
</style>
<style lang="less">
.modal-base-small {
  min-width: 500px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Automatedmessages.vue